import Report from './src/report-combined';
export default Report;